import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonBaseComponent } from '../common-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CheckboxModule, TranslateModule],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent extends CommonBaseComponent {
  @Input() defaultValue: any;
  @Input() name!: string;
  @Input() direction: 'row' | 'column' = 'row';
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
